export function formatValuesWithCondensedUnits(values, delimiter) {
    let unit = '';
    let testForUnitsRegex = /^\d+([^\d]+)\s*$/i;
    let hasUnits = values.reduce((accumulator, current) => {
        let match = testForUnitsRegex.exec(current);
        let hasUnit = false;
        if (match) {
            if (unit === '') {
                unit = match[1];
                hasUnit = true;
            } 
            else if (unit === match[1]) {
                hasUnit = true;
            }
        }
        return hasUnit && accumulator;
    }, true /* assume that we do have an array of numbers with units */)

    let newValues = [];
    let stripUnitsRegex = /^\d+/;
    values.forEach(value => {
        if (hasUnits) {
            let match = stripUnitsRegex.exec(value);
            newValues.push(match[0]);
        }
        else {
            newValues.push(value);
        }
    });
    // make sure to reset the unit if hasUnits is false.
    if (!hasUnits) {
        unit = '';
    }
    else {
        newValues = newValues.sort((a, b) => {
            if (Number(a) < Number(b)) {
                return -1;
            }
            return 1;
        });
    }

    return newValues.join(delimiter) + unit;
}